<template>
  <select
    v-model="tf"
    @change="$emit('change', $event.target.value)"
    class="bg-ontick-graphite-500 rounded text-sm font-medium h-10 border border-ontick-carbon-500 w-full"
  >
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="S15">15 segundos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="S30">30 segundos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT', 'CCMFUT', 'BITFUT'].includes(ticker)" value="M1">1 minuto</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M2">2 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M3">3 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M5">5 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M6">6 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M10">10 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M12">12 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT', 'CCMFUT', 'BITFUT'].includes(ticker)" value="M15">15 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="M30">30 minutos</option>
    <option v-if="['', 'WINFUT', 'WDOFUT'].includes(ticker)" value="H1">1 hora</option>
  </select>
</template>

<script>
export default {
  name: "portfolio-select-timeframe",
  props: {
    ticker: {
      type: String,
      default: "WINFUT",
    },
    timeframe: {
      type: String,
      default: "M15",
    },
  },
  data() {
    return {
      tf: this.timeframe,
    };
  },
  watch: {
    timeframe: {
      deep: true,
      handler(value) {
        this.tf = value;
        return value;
      },
    },
  },
};
</script>
